import React, { useState } from 'react';
import hedaLogo from '../assets/heda-logo_horizontal.jpg';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-primary shadow-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between h-16 px-6">
        {/* Logo */}
        <div
          onClick={() => navigate('/')}
          className="cursor-pointer flex items-center"
        >
          <img src={hedaLogo} alt="和達法律事務所" className="h-16 object-contain" />
        </div>

        {/* 桌機版選單 */}
        <nav className="hidden md:flex space-x-6 text-textOppPrimary font-ec">
          <a href="/" className="hover:text-accent">首頁</a>
          <a href="/services" className="hover:text-accent">服務項目</a>
          <a href="/team" className="hover:text-accent">團隊介紹</a>
          <a href="/news" className="hover:text-accent">最新消息</a>
          <a href="/contact" className="hover:text-accent">聯絡我們</a>
        </nav>

        {/* 手機版漢堡按鈕 */}
        <button
          className="md:hidden text-textOppPrimary text-2xl"
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </button>
      </div>

      {/* 手機版抽屜選單 */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40" onClick={() => setMenuOpen(false)}>
          <div
            className="absolute top-0 left-0 h-full w-2/3 bg-white shadow-lg p-6"
            onClick={(e) => e.stopPropagation()} // 防止點擊抽屜關閉
          >
            <button
              className="text-xl mb-6"
              onClick={() => setMenuOpen(false)}
            >
              ✕
            </button>
            <nav className="flex flex-col gap-4 text-lg text-gray-800">
              <a href="/" onClick={() => setMenuOpen(false)}>首頁</a>
              <a href="/services" onClick={() => setMenuOpen(false)}>服務項目</a>
              <a href="/team" onClick={() => setMenuOpen(false)}>團隊介紹</a>
              <a href="/news" onClick={() => setMenuOpen(false)}>最新消息</a>
              <a href="/contact" onClick={() => setMenuOpen(false)}>聯絡我們</a>
            </nav>
          </div>
        </div>
      )}
    </header>
      );
}

export default Header;
